import React from "react";
import Icon from "@material-ui/core/Icon";

const RemoveButton = (props) => {
  return (
    <button
      aria-label={`Remove ${props.type}`}
      className="btn btn-link"
      onClick={props.removeItem}
    >
      <Icon className="mr-2 text-danger">delete</Icon>
    </button>
  );
};

export default RemoveButton;
